import { render, staticRenderFns } from "./activityDataInfo.vue?vue&type=template&id=73f88b15&"
import script from "./activityDataInfo.vue?vue&type=script&lang=js&"
export * from "./activityDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./activityDataInfo.vue?vue&type=style&index=0&id=73f88b15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports